module.exports = __webpack_public_path__ + "img/noun_digging_164791.a76b96f9.svg";